import { Component } from "@angular/core";
import { Router, NavigationStart, Event, NavigationEnd } from "@angular/router";
import { isPlatformBrowser } from "@angular/common";
declare var $: any;
import * as AOS from "aos";
import { CookieService } from "ngx-cookie-service";
import {
  FormGroup,
  FormControl,
  Validators,
  FormBuilder,
} from "@angular/forms";
import { environment } from "src/environments/environment";
import { AboutUsService } from "./about-us/about-us.service";
import { HostListener } from "@angular/core";

declare let fbq: Function;

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.css"],
})
export class AppComponent {
  title = environment.clinicName;
  currentUrl: string;
  isHome;
  sendMessages = [];
  RecievedMessages = [];
  ioConnection: any;
  messageContent: string;
  socket;
  NewUserForm: FormGroup;
  submitted = false;
  UserName = "";
  isFabs = true;
  public emailPattern = environment.emailPattern;
  public phonePattern = environment.phonePattern;
  composeForm: FormGroup;
  composeFormSubmitted = false;
  // emailSubject =
  //   "<p>Lisa, would like to recommend this fabulous treatment to you from Smile Orchard.</p>";

  LoggedInUserName;
  userNameFormSubmitted = false;
  UserNameForm;
  websiteUrl = environment.websiteUrl;
  isSuccess = false;
  IsLoggedInUserName = true;
  isError = false;
  Notes;
  currentUrl2;
  whatsappUrl = "";
  isContactUs = true;
  videoCdnUrl = environment.googleCDNUrl;
  RecieverName = "";

  constructor(
    private router: Router,
    private cookieService: CookieService,
    private fb: FormBuilder,
    private aboutUsService: AboutUsService
  ) {
    this.router.events.subscribe((routerEvent: Event) => {
      if (routerEvent instanceof NavigationStart) {
        this.currentUrl = routerEvent.url.substring(
          routerEvent.url.lastIndexOf("/") + 1
        );
        if (
          this.currentUrl.trim() === "" ||
          this.currentUrl.trim() === "Home"
        ) {
          this.isHome = true;
          this.isFabs = false;
          const newThis = this;
          $(window).on("scroll", function () {
            newThis.isFabs = true;
            var $w = $(this),
              st = $w.scrollTop(),
              navbar = $(".smileOrchard-navbar");

            if (st > 150) {
              if (!navbar.hasClass("scrolled")) {
                newThis.isFabs = true;
                navbar.addClass("scrolled awake");
              }
            }
            if (st < 150) {
              if (navbar.hasClass("scrolled")) {
                newThis.isFabs = false;
                navbar.removeClass("scrolled sleep");
              }
            }
          });
          $(".navbar").removeAttr("position");
          var $w = $(this),
            navbar = $(".smileOrchard-navbar");
          if (navbar.hasClass("scrolled")) {
            newThis.isFabs = false;
            navbar.removeClass("scrolled sleep");
          }
        } else {
          this.isHome = false;
          this.isFabs = true;
        }

        if (this.currentUrl.trim() === "Contact%20Us") {
          this.isContactUs = false;
        } else {
          this.isContactUs = true;
        }
      }
    });

    router.events.subscribe((y: NavigationEnd) => {
      if (y instanceof NavigationEnd) {
        fbq("track", "PageView");
      }
    });
  }

  ngOnInit() {
    this.currentUrl = this.router.url.substring(
      this.router.url.lastIndexOf("/") + 1
    );

    if (isPlatformBrowser) {
      this.router.events.subscribe((evt) => {
        if (!(evt instanceof NavigationEnd)) {
          return;
        }
        window.scrollTo(0, 0);
      });
    }

    AOS.init({
      disable: "mobile",
      // once: true
    });
    this.formInitialize();
    this.ComposeFormInitialize();

    $(".chat-fab").on("click", function () {
      if ($("#chat-popup").css("display") === "block") {
        $("#web-fab").addClass("d-md-block");
      } else {
        $("#web-fab").removeClass("d-md-block");
      }
    });
  }

  @HostListener("document:visibilitychange", ["$event"])
  visibilitychange() {
    localStorage.clear();
    this.cookieService.delete("isMessageDisplayed");
  }

  formInitialize() {
    this.NewUserForm = this.fb.group({
      FirstName: new FormControl("", Validators.required),
      email: new FormControl("", [Validators.pattern(this.emailPattern)]),
      phoneNumber: new FormControl("", [
        Validators.required,
        Validators.pattern(this.phonePattern),
      ]),
    });

    this.UserNameForm = this.fb.group({
      name: new FormControl("", Validators.required),
    });
  }

  ComposeFormInitialize() {
    this.composeForm = this.fb.group({
      mailTo: new FormControl("", Validators.required),
      mailToNew: new FormControl(""),
      subject: new FormControl(""),
      emailBody: new FormControl(""),
      senderName: new FormControl("", Validators.required),
      recieverName: new FormControl("", Validators.required),
      notes: new FormControl(""),
    });
  }

  shareOnWhatsapp() {
    if (this.currentUrl === "" || this.currentUrl === "/") {
      this.whatsappUrl = environment.whatsappLink;
    } else {
      this.whatsappUrl =
        environment.whatsappLink + encodeURIComponent(this.currentUrl);
    }
    window.open("https://api.whatsapp.com/send?text=" + this.whatsappUrl);
  }

  showSignUpPopup() {
    if (this.cookieService.get("isLoggedIn")) {
      $("#welcomePopup").hide();
      $("#chatPopup").removeClass("d-none");
      $("#chatPopup").addClass("d-block");
    } else {
      $("#welcomePopup").hide();
      $("#signUpPopup").removeClass("d-none");
      $("#signUpPopup").addClass("d-block");
    }
  }

  onActivate(e) {
    window.scroll(0, 0);
  }

  showMailPopup() {
    $("#ModalEmail").modal("show");
  }

  showEmailForm() {
    this.userNameFormSubmitted = true;
    if (!this.UserNameForm.valid) {
      return true;
    } else {
      this.LoggedInUserName = this.UserNameForm.value.name;
      this.IsLoggedInUserName = true;
    }
  }

  sendMail() {
    this.composeFormSubmitted = true;
    if (!this.composeForm.valid) {
      window.scrollTo(0, 0);
      return true;
    } else {
      var appenedEmails = [];
      appenedEmails = $("#emailsNew").val().split(";");
      appenedEmails.forEach((element) => {
        if (element) {
          if (element.includes("<")) {
            this.composeForm.value.mailToNew +=
              element.split(" <")[0] +
              " : <" +
              element.split(" <")[1] +
              " : P : 0  ; ";
          } else {
            this.composeForm.value.mailToNew +=
              this.composeForm.value.recieverName +
              " : <" +
              element +
              "> : P : 0  ; ";
          }
        }
      });
      if (this.composeForm.value.notes) {
        this.Notes = "" + this.composeForm.value.notes;
      } else {
        this.Notes = "";
      }
      this.LoggedInUserName = this.composeForm.value.senderName;
      var htmlBodyData = $("#emailBody").html();
      htmlBodyData = htmlBodyData.replace(
        "[LoggedInUserName]",
        this.LoggedInUserName
      );
      htmlBodyData = htmlBodyData.replace("[Notes]", this.Notes);
      var htmlSubData = $("#emailSubject").html();
      htmlSubData = htmlSubData.replace(
        "[LoggedInUserName]",
        this.LoggedInUserName
      );

      htmlBodyData = htmlBodyData.replace(
        "[RecieverName]",
        this.composeForm.value.recieverName
      );
      var emailData = {
          mailSubject: htmlSubData,
          mailTo: this.composeForm.value.mailToNew,
          emailDescription: htmlBodyData,
          TemplateID: 0,
          StaffIDSentBy: 0,
      };
      this.aboutUsService.sendMassEmails(emailData).subscribe(
        (res) => {
          if (res["success"]) {
            this.IsLoggedInUserName = false;
            this.isSuccess = true;
            this.isError = false;
          } else {
            this.isSuccess = false;
            this.isError = true;
            this.IsLoggedInUserName = false;
          }
        },
        () => {
          this.isSuccess = false;
          this.isError = true;
          this.IsLoggedInUserName = false;
        }
      );
    }
  }

  cancelEmail() {
    this.composeForm.reset();
    this.composeFormSubmitted = false;
    this.IsLoggedInUserName = true;
    this.isSuccess = false;
    this.isError = false;
    $("#ModalCenter").modal("hide");
    this.ComposeFormInitialize();
  }

  resetModal() {
    this.composeForm.reset();
    this.composeFormSubmitted = false;
    this.IsLoggedInUserName = true;
    this.isSuccess = false;
    this.isError = false;
    this.ComposeFormInitialize();
  }

  openWhatsappChat() {
    window.open("https://wa.me/447393708526", "_blank");
    // window.open('https://api.whatsapp.com/send?phone=+447393708526', '_blank')
  }

  BookAppointment() {
    if (this.cookieService.get("isLoggedIn")) {
      this.router.navigate([
        "/Contact Us",
        { Reason: "Smile Design" },
      ]);
    } else {
      this.router.navigate([
        "/Contact Us",
        { IsAppointment: 1, Reason: "Smile Design" },
      ]);
    }
  }
}
